import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./ContainerMasterEmailWindow.css";
import { toast } from "react-toastify";
import moment from "moment";
import {
	useTable,
	usePagination,
	useSortBy,
	useExpanded,
	useGlobalFilter,
	useRowSelect,
} from "react-table";
import { TableCheckbox } from "../components/common/tables/TableCheckbox";
import {
	htmlEmailSendWithAttachment,
	VGMRecepient,
	CC_VGMRecepient,
} from "../services/emailService";
import { ContainerMasterMailBody } from "./ContainerMasterMailBody";
import store from "../store/Store";
import { filter } from "lodash";
import { FormatContainerMasterDataForEmail } from "../utils/dataFilter";
import { CONTAINERMASTER_DATA_EMAIL_COLUMNS } from "../components/columns/containerMasterColumns";
import { getContainerMasterData } from "../services/ContainerMasterService";
import MainTablePaginationAdv from "../components/common/tables/MainTablePaginationAdv";
import noDataAvailable from "../assets/img/noDataAvailable.png";
import {
	emailStatusContainerMasterTractor,
	emailStatusContainerMasterAggregate,
	emailStatusContainerMasterFiveM,
} from "../services/emailService";
import { dispatcher } from "../store/storeHelpers";
import * as actionTypes from "../store/ActionTypes";
import Counters from "../components/common/Counters";
import { PulseLoader } from "react-spinners";

function ContainerMasterEmailWindow({ type }) {
	const [emailBtn, setEmailBtn] = useState("Send Email");
	const [emailData, setEmailData] = useState([]);
	const [planDate, setPlanDate] = useState({
		fromdate: moment().format("YYYY-MM-DD"),
		todate: moment().format("YYYY-MM-DD"),
	});
	const [tableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);
	const [noDataState, setNoDataState] = useState(false);

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setUserData(Object.values(store.getState().userAccessData));
			setTableData(Object.values(store.getState().containerMaster_email));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (filter(userData, { MenuName: "VGM Email", View: 1 }).length > 0) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "VGM Email", View: 1 })
			);
		}
	}, [userData]);

	var allowToSend = filter(filteredUserAccessData, { SendEmail: 1 }).length > 0;
	const resetStorage = () => {
		setTableData([]);
	};
	useEffect(() => {
		async function getPlan() {
			if (type === "ContainerMasterWindow") {
				var filterData = [];
				resetStorage();
				setLoading(true);
				try {
					setNoDataState(false);
					const response = await getContainerMasterData(planDate, "ContainerMaster");
					for (let i = 0; i < response.data.length; i++) {
						if (response.data[i]["Gate_In_Date"]) {
							filterData.push(response.data[i]);
						}
					}
					if(filterData.length === 0){
						setNoDataState(true);
					}
					dispatcher(
						actionTypes.CONTAINERMASTER_EMAIL_DATA,
						FormatContainerMasterDataForEmail(filterData)
					);
					// setTableData(FormatContainerMasterDataForEmail(filterData));
					setLoading(false);
				} catch (error) {
					setLoading(false);
					if (error.response.data.StatusCode === 404) {
						setNoDataState(true);
					}
				}
			}
		}
		getPlan();
	}, [planDate, type]);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		state,
		setPageSize,
		canPreviousPage,
		prepareRow,
		selectedFlatRows,
		setGlobalFilter,
	} = useTable(
		{
			columns: CONTAINERMASTER_DATA_EMAIL_COLUMNS,
			data: tableData,
			autoResetPage: false,
			initialState: { pageSize: 50 },
			autoResetExpanded: false,
			autoResetGlobalFilter: false,
		},
		useGlobalFilter,
		useSortBy,
		useExpanded,
		usePagination,
		useRowSelect,
		(hooks) => {
			hooks.visibleColumns.push((columns) => [
				{
					id: "selection",
					Header: ({ getToggleAllPageRowsSelectedProps }) => (
						<div>
							<TableCheckbox {...getToggleAllPageRowsSelectedProps()} />
						</div>
					),
					Cell: ({ row }) => (
						<div>
							<TableCheckbox {...row.getToggleRowSelectedProps()} />
						</div>
					),
				},
				...columns,
			]);
		}
	);
	const { pageIndex, pageSize, globalFilter } = state;

	useEffect(() => {
		var planningId = [];
		for (let i = 0; i < selectedFlatRows.length; i++) {
			planningId.push(selectedFlatRows[i].original);
		}
		setEmailData(planningId);
	}, [selectedFlatRows]);

	async function sendEmailHandler() {
		let tractorArray = filter(emailData, { DataOf: "TRACTOR" });
		let aggregateArray = filter(emailData, { DataOf: "AGGREGATE" });
		let fiveMArray = filter(emailData, { DataOf: "5M" });
		let statusTractorIdList = "";
		let statusAggregateIdList = "";
		let statusFiveMIdList = "";
		for (let i = 0; i < tractorArray.length; i++) {
			if (i !== tractorArray.length - 1) {
				statusTractorIdList += tractorArray[i]["ContainerMasterId"] + ",";
			} else {
				statusTractorIdList += tractorArray[i]["ContainerMasterId"];
			}
		}
		for (let i = 0; i < aggregateArray.length; i++) {
			if (i !== aggregateArray.length - 1) {
				statusAggregateIdList += aggregateArray[i]["ContainerMasterId"] + ",";
			} else {
				statusAggregateIdList += aggregateArray[i]["ContainerMasterId"];
			}
		}
		for (let i = 0; i < fiveMArray.length; i++) {
			if (i !== fiveMArray.length - 1) {
				statusFiveMIdList += fiveMArray[i]["ContainerMasterId"] + ",";
			} else {
				statusFiveMIdList += fiveMArray[i]["ContainerMasterId"];
			}
		}
		try {
			setEmailBtn("Sending...");
			await htmlEmailSendWithAttachment({
				Mailto: VGMRecepient,
				MailCc: CC_VGMRecepient,
				strSubject: `Container Master Details-${moment().format("DD-MM-YYYY")}`,
				body: ContainerMasterMailBody(emailData),
				attachment: [],
			});
			setEmailBtn("Send Email");
			toast.success("Email sent successfully");
			if (statusTractorIdList !== "") {
				await emailStatusContainerMasterTractor({
					ContainerMasterId: statusTractorIdList,
					isEmailSentTractor: 1,
				});
				dispatcher(actionTypes.UPDATE_CONTAINERMASTER_EMAIL_DATA_TRACTOR, {
					data: emailData,
					isEmailSentTractor: 1,
				});
			}
			if (statusAggregateIdList !== "") {
				await emailStatusContainerMasterAggregate({
					ContainerMasterId: statusAggregateIdList,
					isEmailSentAggregate: 1,
				});
				dispatcher(actionTypes.UPDATE_CONTAINERMASTER_EMAIL_DATA_AGGREGATE, {
					data: emailData,
					isEmailSentAggregate: 1,
				});
			}
			if (statusFiveMIdList !== "") {
				await emailStatusContainerMasterFiveM({
					ContainerMasterId: statusFiveMIdList,
					isEmailSent5M: 1,
				});
				dispatcher(actionTypes.UPDATE_CONTAINERMASTER_EMAIL_DATA_5M, {
					data: emailData,
					isEmailSent5M: 1,
				});
			}
		} catch (error) {
			setEmailBtn("Send Email");
			toast.error("Unable to send email...please try again.");
		}
	}

	return (
		<>
			<div className="emailWindow__container">
				<div className="containerMasterEmailWindowCounterDiv">
					<Counters
						counter={{
							Total: tableData.length !== 0 ? tableData.length : 0,
						}}
						label={["Total"]}
						styleData="df_dailyCounter absolute"
					/>
				</div>
				<div className="invPackingEmail__header__containerMaster">
					<Form.Control
						value={globalFilter || ""}
						onChange={(e) => setGlobalFilter(e.target.value)}
						className="hiden-inp"
						placeholder="search here.."
						style={{ width: "30%" }}
					/>
					<div
						style={{
							display: "flex",
							width: "30%",
							alignItems: "center",
							marginLeft: "10px",
						}}
					>
						<strong>From-</strong>
						<Form.Control
							type="date"
							value={planDate.fromdate}
							onChange={(e) =>{
								setPlanDate({ ...planDate, fromdate: e.target.value })
								if(e.target.value <= planDate.todate){
									setPlanDate({ ...planDate, fromdate: e.target.value })
								}else{
									setPlanDate({ ...planDate, fromdate: planDate.fromdate })
									alert('From date should not greater than To date.')
								}
							}}
							name="fromDate"
						/>
					</div>
					<div
						style={{
							display: "flex",
							width: "30%",
							alignItems: "center",
							marginLeft: "10px",
						}}
					>
						<strong>To-</strong>
						<Form.Control
							type="date"
							value={planDate.todate}
							onChange={(e) =>{
								if(e.target.value >= planDate.fromdate){
									setPlanDate({ ...planDate, todate: e.target.value })
								}else{
									setPlanDate({ ...planDate, todate: planDate.todate })
									alert('To date should not lesser than From date.')
								}
							}}
							name="toDate"
						/>
					</div>
					<Button
						className="btn-primary btn-pill btn-sm mr4 sb sendInvPackingMailBtn__containerMaster"
						onClick={sendEmailHandler}
						disabled={
							emailData.length === 0 ||
							emailBtn === "Sending..." ||
							!allowToSend
						}
						style={{ marginLeft: "10px", marginRight: "20px" }}
					>
						<i class="bx bxs-send"></i>
					</Button>
				</div>
				{/* <hr /> */}
				{loading && (
					<PulseLoader
						color="#007bff"
						size="20px"
						margin="10px"
						style={{ position: "absolute", top: "50vh", left: "45%" }}
					/>
				)}
				{noDataState && (
					<img
						src={noDataAvailable}
						alt="notAvailableImg"
						className="noDataFoundImg"
						// style={{ marginLeft: "-2%" }}
					/>
				)}
				{!noDataState && (
					<>
						<div className="table_container__containerMaster">
							<table {...getTableProps()} className="table mtbs">
								<thead>
									{headerGroups.map((headerGroup) => (
										<tr {...headerGroup.getHeaderGroupProps()}>
											{headerGroup.headers.map((column) => (
												<th
													{...column.getHeaderProps(
														column.getSortByToggleProps()
													)}
												>
													{column.render("Header")}
													{column.id !== "selection" && (
														<i
															className={
																column.isSorted
																	? column.isSortedDesc
																		? "fi fi-rr-angle-small-down head-icon"
																		: "fi fi-rr-angle-small-up head-icon"
																	: "fi fi-rr-circle-small head-icon w"
															}
														></i>
													)}
												</th>
											))}
										</tr>
									))}
								</thead>
								<tbody {...getTableBodyProps()}>
									{page.map((row) => {
										prepareRow(row);
										return (
											<tr {...row.getRowProps()}>
												{row.cells.map((cell) => {
													return (
														<td
															{...cell.getCellProps()}
															className={
																cell.row.subRows.length !== 0
																	? "main-row"
																	: "sub-row"
															}
														>
															{cell.column.id === "email_status" &&
																(cell.row.original.isEmailSentTractor === 1 ||
																	cell.row.original.isEmailSentAggregate ===
																		1 ||
																	cell.row.original.isEmailSent5M === 1) && (
																	<button
																		style={{
																			display: "flex",
																			alignItems: "center",
																			marginLeft: "35px",
																			border: "none",
																		}}
																	>
																		<i
																			class="bx bxs-badge-check"
																			style={{
																				color: "green",
																				background: "transparent",
																				transform: "scale(2)",
																			}}
																		></i>
																	</button>
																)}
															<div className="cell-wrap">
																{cell.render("Cell")}
															</div>
														</td>
													);
												})}
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
						{/* <MainTablePagination
          nextPage={nextPage}
          previousPage={previousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          canPreviousPage={canPreviousPage}
          setPageSize={setPageSize}
        /> */}
						<MainTablePaginationAdv
							nextPage={nextPage}
							previousPage={previousPage}
							canNextPage={canNextPage}
							pageIndex={pageIndex}
							pageOptions={pageOptions}
							pageSize={pageSize}
							canPreviousPage={canPreviousPage}
							setPageSize={setPageSize}
							gotoPage={gotoPage}
							pageCount={pageCount}
						/>
					</>
				)}
			</div>
		</>
	);
}
export default ContainerMasterEmailWindow;
